export default "__VITE_ASSET__DY6OEyRv__"